import { gql } from "@apollo/client";

export default gql`
  mutation AcceptGroupRequest($requestId: ObjectId!) {
    acceptGroupRequest(requestId: $requestId)
  }
`;
